import React from "react";
import { motion } from "framer-motion";
import styles from "./Vpd.module.scss";

// --- Centralized Icons ---
const Icons = {
  Refresh: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125"
      ></path>
    </svg>
  ),
  Code: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a2.25 2.25 0 01.9-1.872l7.906-3.839A2.25 2.25 0 0118.105 3H5.895a2.25 2.25 0 00-2.03 2.018L3.75 14.25m0 0a2.25 2.25 0 002.25 2.25h13.5a2.25 2.25 0 002.25-2.25m-16.5-3V9.75m16.5 3v2.25m0 0V9.75m0 2.25h-3"
      ></path>
    </svg>
  ),
  Layers: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25a1.125 1.125 0 011.125-1.125h.75m7.5 10.375v3.375c0 .621-.504 1.125-1.125 1.125H18.75M4.5 7.5v9a1.125 1.125 0 001.125 1.125H15M12 2.25v9m0 0l3-3m-3 3l-3-3"
      ></path>
    </svg>
  ),
  Video: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
      ></path>
    </svg>
  ),
  Analyze: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 5.25l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
      ></path>
    </svg>
  ),
  Builder: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625a2.25 2.25 0 00-2.25 2.25v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
      ></path>
    </svg>
  ),
  CheckCircle: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
      ></path>
    </svg>
  ),
  Extract: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
      ></path>
    </svg>
  ),
  ArrowDown: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 14l-7 7m0 0l-7-7m7 7V3"
      ></path>
    </svg>
  ),
  CheckTick: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="3"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polygon points="12 2 2 7 22 7 12 2"></polygon>
      <polyline points="2 17 22 17"></polyline>
      <polyline points="2 22 22 22"></polyline>
      <line x1="6" y1="17" x2="6" y2="7"></line>
      <line x1="10" y1="17" x2="10" y2="7"></line>
      <line x1="14" y1="17" x2="14" y2="7"></line>
      <line x1="18" y1="17" x2="18" y2="7"></line>
    </svg>
  ),
  Clipboard: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  Server: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
      <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
      <line x1="6" y1="6" x2="6.01" y2="6"></line>
      <line x1="6" y1="18" x2="6.01" y2="18"></line>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  CreditCard: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  UserFocus: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom New Hero Art: Video KYC Interface Animation ---
const VpdHeroArt = () => (
  <div className={styles["vpd-hero-art"]} aria-hidden>
    <svg
      className={styles["vpd-hero-svg"]}
      viewBox="0 0 400 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="vpd-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background connection lines */}
      <path
        d="M80 150 L140 150 M320 120 L260 120 M300 240 L260 240"
        stroke="rgba(99, 102, 241, 0.3)"
        strokeWidth="2"
        strokeDasharray="4 4"
        className={styles["vpd-anim-dash"]}
      />

      {/* Nodes floating around */}
      <rect
        x="25"
        y="130"
        width="60"
        height="40"
        rx="6"
        fill="rgba(14, 165, 233, 0.1)"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        className={styles["vpd-float-node1"]}
      />
      <text
        x="35"
        y="153"
        fill="#0ea5e9"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        VIDEO
      </text>

      <rect
        x="320"
        y="100"
        width="50"
        height="40"
        rx="6"
        fill="rgba(79, 70, 229, 0.1)"
        stroke="#4f46e5"
        strokeWidth="1.5"
        className={styles["vpd-float-node2"]}
      />
      <text
        x="330"
        y="123"
        fill="#4f46e5"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        OCR
      </text>

      <rect
        x="300"
        y="220"
        width="60"
        height="40"
        rx="6"
        fill="rgba(16, 185, 129, 0.1)"
        stroke="#10b981"
        strokeWidth="1.5"
        className={styles["vpd-float-node3"]}
      />
      <text
        x="313"
        y="243"
        fill="#10b981"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        KYC
      </text>

      {/* Central Video KYC Interface */}
      <rect
        x="130"
        y="50"
        width="140"
        height="220"
        rx="12"
        fill="rgba(255,255,255,0.03)"
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="2"
      />

      {/* User Profile UI */}
      <circle
        cx="200"
        cy="110"
        r="30"
        stroke="#94a3b8"
        strokeWidth="3"
        fill="none"
      />
      <circle cx="200" cy="100" r="10" fill="#94a3b8" />
      <path
        d="M180 130 Q200 115 220 130"
        stroke="#94a3b8"
        strokeWidth="3"
        fill="none"
      />

      {/* OCR Document Capture UI */}
      <rect
        x="150"
        y="160"
        width="100"
        height="60"
        rx="4"
        stroke="#38bdf8"
        strokeWidth="2"
        fill="none"
        className={styles["vpd-anim-doc"]}
      />
      <line
        x1="160"
        y1="175"
        x2="200"
        y2="175"
        stroke="#38bdf8"
        strokeWidth="2"
      />
      <line
        x1="160"
        y1="190"
        x2="220"
        y2="190"
        stroke="#38bdf8"
        strokeWidth="2"
      />
      <line
        x1="160"
        y1="205"
        x2="190"
        y2="205"
        stroke="#38bdf8"
        strokeWidth="2"
      />

      {/* Face Match / Facial Recognition Scanner Line */}
      <line
        x1="160"
        y1="80"
        x2="240"
        y2="80"
        stroke="#10b981"
        strokeWidth="3"
        filter="url(#vpd-glow)"
        className={styles["vpd-anim-scanner"]}
      />
    </svg>
  </div>
);

const VPDPlatform = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION (REDESIGNED) */}
        <section className={styles["vpd-hero"]}>
          <div className={styles["vpd-hero-mesh"]} />
          <div className={styles["vpd-hero-glow-1"]} />
          <div className={styles["vpd-hero-glow-2"]} />

          <div className="sec-container">
            <div className={styles["vpd-hero-row"]}>
              <motion.div
                className={styles["vpd-hero-inner"]}
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Enterprise Video KYC
                  SaaS
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  <span className="product-text-gradient">VPD</span> - Fast &
                  Secure Customer Verification
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Verify customers remotely. Reduce fraud. Stay compliant.
                </motion.p>
                <motion.p className="product-sublead" variants={childVariants}>
                  VPD is a powerful Video KYC SaaS platform that helps banks,
                  NBFCs, and fintech companies onboard customers through
                  real-time video verification, document capture, and
                  intelligent validation all in one seamless workflow.
                </motion.p>
                <motion.div className={styles["vpd-pills"]} variants={childVariants}>
                  <span className={styles["vpd-pill"]}>No Physical Visits</span>
                  <span className={styles["vpd-pill"]}>No Delays</span>
                  <span className={styles["vpd-pill"]}>Secure Digital Onboarding</span>
                </motion.div>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Book a Demo
                  </a>
                  <a
                    href="/contact"
                    className="product-btn product-btn-outline"
                  >
                    Talk to Our Team
                  </a>
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <VpdHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. WHY DIFFERENT (Hover Effect: 3D Tilt) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Why VPD is Different</h2>
              <p className="gen-h2-sub">
                Unlike typical verification tools, VPD offers an end-to-end
                integrated solution.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ffedd5",
                    color: "#ea580c",
                    borderColor: "#ffedd5",
                  }}
                >
                  <Icons.Video />
                </div>
                <h3 className="product-card-title">Complete Workflow</h3>
                <p className="product-card-desc">
                  Unified video, document capture, and consent workflow managed
                  in one platform.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Shield />
                </div>
                <h3 className="product-card-title">Built-in Compliance</h3>
                <p className="product-card-desc">
                  Integrated compliance modules with full audit trails and
                  geo-location session tracking.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dbeafe",
                    color: "#2563eb",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.Cloud />
                </div>
                <h3 className="product-card-title">Multi-Tenant SaaS</h3>
                <p className="product-card-desc">
                  Designed specifically for banks and lending partners to manage
                  end-to-end KYC lifecycles.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 3. TRUST & PARTNERS STRIP */}
        {/* <section
          className="product-section product-section-alt"
          style={{ padding: "6.4rem 0" }}
        >
          <div className="sec-container">
            <p className="product-strip-label">Built on secure infrastructure</p>
            <div className="product-partner-strip">
              <div className="product-partner-box">AWS Compatible</div>
              <div className="product-partner-box">Azure Compatible</div>
              <div className="product-partner-box">Encrypted Storage</div>
              <div className="product-partner-box">Enterprise Cloud</div>
            </div>
          </div>
        </section> */}

        {/* 4. BUSINESS IMPACT (Hover Effect: Soft Scale) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Designed for Real Business Impact</h2>
            </motion.div>
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">Minutes</p>
                <p className="product-stat-label">Faster Onboarding vs Days</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">Lower</p>
                <p className="product-stat-label">Operational Costs</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">Reduced</p>
                <p className="product-stat-label">Fraud & Manual Errors</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">Anywhere</p>
                <p className="product-stat-label">Enable Remote KYC</p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 5. PROBLEM SECTION (Hover Effect: Warning Wobble) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              style={{ textAlign: "left", marginLeft: 0 }}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Physical KYC workflows hold you back</h2>
              <p className="gen-h2-sub">
                Traditional verification processes are slow, manual, and prone
                to risk.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div className="product-prob-num">1</div>
                <h3 className="product-prob-title">Physical Visits</h3>
                <p className="product-card-desc">
                  Forcing customers to visit branches leads to high drop-off
                  rates.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#fef3c7", color: "#d97706" }}
                >
                  2
                </div>
                <h3 className="product-prob-title">Onboarding Delays</h3>
                <p className="product-card-desc">
                  Manual document verification takes days, slowing down
                  business.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#ffedd5", color: "#ea580c" }}
                >
                  3
                </div>
                <h3 className="product-prob-title">Identity Fraud</h3>
                <p className="product-card-desc">
                  Basic verification methods fail to prevent sophisticated
                  impersonations.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#ffe4e6", color: "#e11d48" }}
                >
                  4
                </div>
                <h3 className="product-prob-title">Compliance Gaps</h3>
                <p className="product-card-desc">
                  Fragmented tools leave critical gaps in your regulatory audit
                  trails.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 6. SOLUTION SECTION */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-split"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div variants={childVariants}>
                <h2 className="gen-h2">Start KYC in Seconds</h2>
                <p className="gen-h2-sub">
                  VPD connects agents and customers seamlessly. Initiate
                  requests and track statuses via API or our intuitive
                  dashboard.
                </p>
                <ul className="product-checklist">
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      <strong>Agent Initiation:</strong> Log in and enter basic
                      customer details like name, mobile number, and ID proof to
                      generate a secure link.
                    </span>
                  </li>
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      <strong>Interactive Sessions:</strong> Connect via live
                      video where the agent verifies the customer through OTP
                      and real-time interaction.
                    </span>
                  </li>
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      <strong>Live Dashboards:</strong> Admins can track KYC
                      status, performance, and approvals in real time.
                    </span>
                  </li>
                </ul>
              </motion.div>
              <motion.div
                variants={childVariants}
                className="product-code-block"
              >
                <pre>
                  <span className="product-code-comment">
                    // Initiate Video KYC Session via API
                  </span>
                  <br />
                  <br />
                  <span className="product-code-method">POST</span>{" "}
                  <span className="product-code-url">
                    /v1/kyc/session/create
                  </span>
                  <br />
                  {`{`}
                  <br />
                  <span className="product-code-key">
                    {" "}
                    "customer_mobile"
                  </span>:{" "}
                  <span className="product-code-str">"+91-9876543210"</span>,
                  <br />
                  <span className="product-code-key">
                    {" "}
                    "customer_name"
                  </span>: <span className="product-code-str">"John Doe"</span>,
                  <br />
                  <span className="product-code-key">
                    {" "}
                    "required_documents"
                  </span>
                  : [<span className="product-code-str">"PAN"</span>,{" "}
                  <span className="product-code-str">"Aadhaar"</span>],
                  <br />
                  <span className="product-code-key">
                    {" "}
                    "notify_customer"
                  </span>: <span className="product-code-str">true</span>
                  <br />
                  {`}`}
                  <br />
                  <br />
                  <span className="product-code-comment">
                    // → Returns secure session link & OTP
                  </span>
                </pre>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 7. FEATURES (Why Choose VPD) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Why Choose VPD?</h2>
              <p className="gen-h2-sub">
                Everything you need for secure digital onboarding in one
                platform.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Video />
                </div>
                <h3 className="product-card-title">Real-Time Video KYC</h3>
                <p className="product-card-desc">
                  Verify customers instantly through highly secure, encrypted
                  live video sessions.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ffedd5",
                    color: "#ea580c",
                    borderColor: "#ffedd5",
                  }}
                >
                  <Icons.Extract />
                </div>
                <h3 className="product-card-title">Smart Document Capture</h3>
                <p className="product-card-desc">
                  Capture Aadhaar, PAN, and customer photos instantly with
                  built-in OCR support.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-purple"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                  }}
                >
                  <Icons.UserFocus />
                </div>
                <h3 className="product-card-title">AI-Powered Validation</h3>
                <p className="product-card-desc">
                  Advanced face match and automated document verification for
                  proactive fraud prevention.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.TrendingUp />
                </div>
                <h3 className="product-card-title">Live Dashboard & Reports</h3>
                <p className="product-card-desc">
                  Track real-time KYC statuses, agent performance, and team
                  approvals efficiently.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 9. HOW VPD WORKS WORKFLOW */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">How VPD Works</h2>
              <p className="gen-h2-sub">
                A streamlined, 5-step process to onboard customers securely.
              </p>
            </motion.div>
            <motion.div
              className="product-workflow"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">1. Start KYC</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  Agent enters details
                </p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div
                className="product-wf-step product-wf-step--highlight"
                variants={childVariants}
              >
                <p className="product-wf-title">2. Secure Video</p>
                <p className="product-wf-sub">Live customer interaction</p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">3. Capture Docs</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  OCR extracts data
                </p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">4. Review</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  Admin approves/rejects
                </p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">5. Notify</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  Customer receives updates
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 10. INDUSTRIES & USE CASES (Hover Effect: Elegant Lifts & Slide Ups) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Who Uses VPD?</h2>
              <p className="gen-h2-sub">
                Trusted across the financial sector for robust identity
                verification.
              </p>
            </motion.div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "2.4rem",
              }}
            >
              {[
                {
                  name: "Banks & Institutions",
                  icon: Icons.Bank,
                  hoverClass: "product-hover-lift",
                  color: "#3b82f6",
                  bg: "#eff6ff",
                },
                {
                  name: "NBFCs & Lending",
                  icon: Icons.CreditCard,
                  hoverClass: "product-hover-industry-scale",
                  color: "#10b981",
                  bg: "#ecfdf5",
                },
                {
                  name: "FinTech Startups",
                  icon: Icons.TrendingUp,
                  hoverClass: "product-hover-industry-purple",
                  color: "#a855f7",
                  bg: "#faf5ff",
                },
                {
                  name: "Insurance Companies",
                  icon: Icons.Shield,
                  hoverClass: "product-hover-industry-emerald",
                  color: "#059669",
                  bg: "#ecfdf5",
                },
              ].map((ind) => {
                const Icon = ind.icon;
                return (
                  <div
                    key={ind.name}
                    className={`product-industry-card ${ind.hoverClass}`}
                    style={{ padding: "3.2rem 2.4rem" }}
                  >
                    <div
                      className="product-industry-icon"
                      style={{
                        backgroundColor: ind.bg,
                        color: ind.color,
                        width: "6.4rem",
                        height: "6.4rem",
                        fontSize: "2.8rem",
                      }}
                    >
                      <Icon />
                    </div>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        color: "#0f172a",
                      }}
                    >
                      {ind.name}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* 11. SECURITY & COMPLIANCE (Hover Effect: Inset Press) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Built for Compliance & Security</h2>
              <p className="gen-h2-sub">
                VPD ensures your KYC process strictly meets regulatory
                expectations.
              </p>
            </motion.div>

            <div className="product-grid-4">
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Full Audit Trail
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Every action is logged and tracked to ensure regulatory
                  readiness.
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Encrypted Storage
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Secure, tokenized access control for video and document data
                  at rest.
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Role-Based Access
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Strict access controls mapping directly to agent, reviewer,
                  and admin hierarchies.
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Secure Infrastructure
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Deployed on highly secure cloud environments compatible with
                  AWS and Azure.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 13. COMPARISON SECTION */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <div className="product-section-head">
              <h2 className="gen-h2">See the VPD Difference</h2>
              <p className="gen-h2-sub">
                Compare our end-to-end platform against traditional verification
                methods.
              </p>
            </div>
            <div className="product-table-wrapper">
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Capabilities</th>
                    <th className="highlight-col">VPD Platform</th>
                    <th>Standard OCR Tools</th>
                    <th>Basic Video Calls</th>
                    <th>Physical KYC</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Real-Time Video Interface", "✓", "—", "✓", "—"],
                    ["AI Face Match & Liveness", "✓", "—", "—", "—"],
                    ["Smart Document Capture (OCR)", "✓", "✓", "—", "—"],
                    [
                      "Geo-location & Session Tracking",
                      "✓",
                      "—",
                      "Partial",
                      "—",
                    ],
                    ["Full Audit Trails & Logs", "✓", "Partial", "—", "Manual"],
                    ["Onboarding Speed", "Minutes", "Minutes", "Hours", "Days"],
                    ["End-to-End Lifecycle Management", "✓", "—", "—", "—"],
                  ].map((row, i) => (
                    <tr key={i}>
                      <td>{row[0]}</td>
                      <td
                        className="highlight-col"
                        style={{
                          color:
                            row[1] === "✓" || row[1] === "Minutes"
                              ? "#4f46e5"
                              : "inherit",
                          fontWeight:
                            row[1] === "✓" || row[1] === "Minutes"
                              ? "bold"
                              : "normal",
                        }}
                      >
                        {row[1]}
                      </td>
                      <td>{row[2]}</td>
                      <td>{row[3]}</td>
                      <td>{row[4]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* 14. FINAL CTA */}
        <section className="product-section" style={{ padding: "12rem 0" }}>
          <div className="sec-container" style={{ textAlign: "center" }}>
            <h2 className="gen-h2">Get Started with VPD</h2>
            <p
              className="gen-h2-sub"
              style={{ maxWidth: "60rem", margin: "0 auto 4.8rem auto" }}
            >
              See how fast and secure KYC can be. Join leading institutions
              onboarding customers remotely.
            </p>
            <div
              className="product-cta-group"
              style={{ justifyContent: "center" }}
            >
              <a href="/contact" className="product-btn product-btn-primary">
                Book a Demo
              </a>
              {/* <a
                href="/api-catalogue-home"
                className="product-btn product-btn-outline"
                style={{ borderColor: "#e2e8f0", color: "#0f172a" }}
              >
                Start in Sandbox
              </a> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VPDPlatform;
